import { ref, Ref } from "vue"
const showResetPopUp: Ref<boolean> = ref(false)

export default showResetPopUp
